<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页/</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="block-container mt10">
            <el-tabs v-model="activeName2" type="card" @tab-click="handleClick">
                <el-tab-pane label="订单详情" name="first">
                    <swb-goods-order-info :selfPath="selfPath" :goodsOrderId="goodsOrderId"></swb-goods-order-info>
                </el-tab-pane>
                <el-tab-pane v-if="!contractClosed" label="配货信息" name="second">
                    <swb-order-goods-alloc-item-list :selfPath="selfPath" :goodsOrderId="goodsOrderId" :manualAllocFlag="manualAllocFlag"></swb-order-goods-alloc-item-list>
                </el-tab-pane>
                <el-tab-pane v-if="!contractClosed" label="发货单" name="third">
                    <swb-goods-ship-voucher-list :goodsOrderId="goodsOrderId" :cancelledFlag="cancelledFlag" :selfPath="selfPath" :noSetheight="true"></swb-goods-ship-voucher-list>
                </el-tab-pane>
                <el-tab-pane v-if="!contractClosed" label="订单操作记录" name="fourth">
                    <swb-goods-order-record-list :goodsOrderId="goodsOrderId"></swb-goods-order-record-list>
                </el-tab-pane>
            </el-tabs>
        </div>

    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import SwbGoodsOrderInfo from './GoodsOrderInfo';
    Vue.regist(SwbGoodsOrderInfo);

    //
    import SwbOrderGoodsAllocItemList from './OrderGoodsAllocItemList';
    Vue.regist(SwbOrderGoodsAllocItemList);

    //
    import SwbGoodsShipVoucherList from './GoodsShipVoucherList';
    Vue.regist(SwbGoodsShipVoucherList);

    //
    import SwbGoodsOrderRecordList from './GoodsOrderRecordList';
    Vue.regist(SwbGoodsOrderRecordList);

    export default {
        name: 'swb-show-goods-order',
        path: '/goods/order/detail',
        pathOld: '/to/show/goods/order',
        avlActions: 'alloc_by_proxy|view|cut_down',
        avlScopes: 'servicer',
        notAsResc: false,
        authen: false,
        desc: '商品订单详情',
        data: function () {
            return {
                activeName2: 'first',
                goodsOrderId: null,
                cancelledFlag: null,
                contractClosed: false,
                manualAllocFlag: null,
                selfPath: Vue.$getClassInfo(this).path
            };
        },
        created: function () {
            this.goodsOrderId = this.$route.query.goodsOrderId || null;
            this.cancelledFlag = this.$route.query.cancelledFlag || false;
            this.manualAllocFlag = Utils.isNoB(this.$route.query.manualAllocFlag);
            let activeName = this.$route.query.activeName || null;
            if(activeName != null) {
                this.activeName2 = activeName;
            }
            let contractClosed = this.$route.query.contractClosed || false;
            if(contractClosed != null) {
                this.contractClosed = contractClosed == 'true' ? true : contractClosed;
                this.contractClosed = contractClosed == 'false' ? false : contractClosed;
            }
        },
        methods: {
            handleClick(tab, event) {
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/compo/order/ShowGoodsOrder.vue